import styled from 'styled-components';
export const wrappper = styled.div`
  .customRadiobtn {
    display: flex;
  }

  .customRadiobtn input {
    //display: none;
  }

  // DOT
  .customRadiobtn.dot b {
    display: none;
    margin-left: auto;
    position: relative;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 2px solid #9b9b9b;
  }

  .customRadiobtn.dot input:checked + b {
    //border: solid 2px;
    display: none;
  }

  .customRadiobtn.dot input:checked + b::after {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: none;
    flex-shrink: 0;
    top: 2px;
    left: 2px;
    //background-color: Theme.$primaryColor;
  }

  // CHECK
  .customRadiobtn.check b {
    position: relative;
    margin-left: auto;
    width: 13px;
    height: 13px;
    border: 1px solid #999999;
    border-radius: 50%;
  }

  .customRadiobtn.check input:checked + b {
    border: solid 1px;
  }

  .customRadiobtn.check input:checked + b::before {
    content: '';
    width: 13px;
    height: 13px;
    border-radius: 50%;
    display: flex;
    flex-shrink: 0;
    position: absolute;
    top: -1px;
    left: -1px;
    //background-color: Theme.$primaryColor;
  }

  .customRadiobtn.check input:checked + b::after {
    content: '';
    position: absolute;
    top: 42%;
    left: 50%;
    display: inline-block;
    height: 4px;
    width: 7px;
    border-bottom: 1.5px solid #ffffff;
    border-left: 1.5px solid #ffffff;
    transform-origin: center;
    transform: translate(-50%, -50%) rotate(-45deg);
  }

  // LISTING RADIO BTN COLOR
  .customRadiobtn.dot.listingRadio input:checked + b {
    border: 2px solid;
  }

  .customRadiobtn.dot.listingRadio input:checked + b::after {
    //background-color: Theme.$blueText;
  }

  .customRadiobtn.check.listingRadio input:checked + b {
    border: 1px solid;
  }

  .customRadiobtn.check.listingRadio input:checked + b::before {
    background-color: Theme.$blueText;
  }

  input[type='radio']:checked {
    background-color: #000; /* Color to indicate the radio is selected */
  }
`;
